import { render, staticRenderFns } from "./ActionFileinto.vue?vue&type=template&id=927e130a"
import script from "./ActionFileinto.vue?vue&type=script&lang=js"
export * from "./ActionFileinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports